/*
 * File: fetch.js
 * Project: <<marketing-system>>
 * File Created: 2018-8-21 11:51:4 AM
 * Author: xiongyang (yang.xiong@meicloud.com)
 * -----
 * Last Modified: 2018-05-14 8:02:02 pm
 * Modified By: xiongyang (yang.xiong@meicloud.com>) (<<git>>)
 * -----
 * Copyright © 2018 - MeiCloud, MeiCloud
 */

import axios from 'axios';
import { Message } from 'element-ui';
import router from '@/router';
import store from '../store';
import { getSession } from '@/utils';
import WhiteList from '@/api/whiteList.js';
import brandWhiteList from '@/api/brandWhiteList.js';

let protocol = window.location.protocol; // 协议
let configParam = {
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 30000, // 请求超时时间
  // withCredentials: true
};

// 测试环境，域名的时候 http://cmms2.midea.com/
if (window.location.href.indexOf('://cmms2') >= 0) {
  configParam.baseURL = 'http://cmms2.midea.com/';
}
if (protocol === 'https:') {
  configParam.baseURL = configParam.baseURL.replace('http:', 'https:');
}

// 创建axios实例
export const fetch = axios.create(configParam);

let configData = null;

// request拦截器
fetch.interceptors.request.use(config => {
  configData = config;
  // 给对应接口加brand参数
  if (config.baseURL.indexOf('/dev/') >= 0) {
    if (config.testerUrl) {
      // 切换测试URL
      // console.log('测试URL');
      config.baseURL = config.baseURL.replace('/dev/', config.testerUrl);
    }
  }
  let brandId = store.getters['user/brand'];
  if (brandWhiteList.indexOf(config.url) === -1 && !config.brandInit) {
    if (config.method.toUpperCase() === 'POST') {
      if (config.data) {
        (config.data)['brand'] = brandId;
      } else {
        config.data = { brand: brandId };
      }
    } else if (config.method.toUpperCase() === 'GET') {
      if (config.params) {
        (config.params)['brand'] = brandId;
      } else {
        config.params = { brand: brandId };
      }
    }
  }
  if (WhiteList.indexOf(config.url) > -1) {
    // 给对应接口加teamId参数
    if (config.method.toUpperCase() === 'POST') {
      if (config.data) {
        (config.data)['teamId'] = getSession('teamId');
      } else {
        config.data = { teamId: getSession('teamId') };
      }
    } else if (config.method.toUpperCase() === 'GET') {
      if (config.params) {
        (config.params)['teamId'] = getSession('teamId');
      } else {
        config.params = { teamId: getSession('teamId') };
      }
    }
  }
  return config;
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// respone拦截器
fetch.interceptors.response.use(
  response => {
    const res = response.data;
    // 暂时隐藏，用uat环境开发
    if (+res.code === 100 || +res.code === 99) {

      Message({
        showClose: true,
        message: '您未登录或登录状态已过期，请重新登录',
        type: 'error',
        duration: 3000
      });
      console.log('您未登录或登录状态已过期，请重新登录222', res, router);

      // 跳走
      // router.push({ name: 'login' });
      // 重置菜单和路由
      if (process.env.ENV_CONFIG === 'dev') {
        window.location.href = window.location.protocol + '//' + window.location.host + '/#/login';
      } else if (process.env.ENV_CONFIG === 'sit' || process.env.ENV_CONFIG === 'uat' || process.env.ENV_CONFIG === 'beta' || process.env.ENV_CONFIG === 'test') {
        window.location.href = window.location.protocol + '//' + window.location.host + process.env.assets_publit_url + '#/login';
      } else {
        window.location.href = window.location.protocol + '//' + window.location.host + '/s/marketingSystem/#/login';
      }
      // 清空缓存
      sessionStorage.clear();
      // store.dispatch('user/setCurrentUser', null);
      // store.dispatch('user/setIsAuthMenu', false);
      store.dispatch('user/logoutClearUserInfo');
      // 纠正一直死循环刷新，请求权限菜单问题
      // store.dispatch('user/flagGetAuthList', true);

    } else if (res.code === 1008) {
      // router.push({ name: 'login' });
      if (process.env.ENV_CONFIG === 'dev') {
        window.location.href = window.location.protocol + '//' + window.location.host + '/#/login';
      } else if (process.env.ENV_CONFIG === 'sit' || process.env.ENV_CONFIG === 'uat' || process.env.ENV_CONFIG === 'beta' || process.env.ENV_CONFIG === 'test') {
        window.location.href = window.location.protocol + '//' + window.location.host + process.env.assets_publit_url + '#/login';
      } else {
        window.location.href = window.location.protocol + '//' + window.location.host + '/s/marketingSystem/#/login';
      }
      // 清空缓存
      console.log('接口出现问题，清空缓存333');
      sessionStorage.clear();
      // store.dispatch('user/setCurrentUser', null);
      // store.dispatch('user/setIsAuthMenu', false);
      store.dispatch('user/logoutClearUserInfo');
    }

    if (res.code === 0 || res.code === '0000' || res.success === true) {
      return response.data;
    } else {
      if (!configData.isNoMsg && res.msg) {
        Message({
          showClose: true,
          message: res.msg,
          type: 'error',
          duration: 3000
        });
      };
      return response.data;
      // return Promise.reject(response.data);
    }
  },
  error => {
    Message({
      showClose: true,
      message: error.message,
      type: 'error',
      duration: 5000
    });
    return Promise.reject(error);
  }
);

export default fetch;
